import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransferConfirmPage, { getDefaultPageData } from "components/pages/TransferConfirmPage";
import AddUnlinkedTransferAccountForm from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountForm";
import AddUnlinkedTransferAccountFormUI from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountFormUI";
import Classes, { Account, UnlinkedAccount } from "model";

/**
 * @name CaptureReviewTransferMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureTransferConfirmationMain(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const { options } = branding;
    const transferScheduleImmediateLabel = options.transfer_schedule_immediate_abi22;
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const defaultAcc = BCMSDefaultModel.account();
    const defaultUnlinkedAcc = BCMSDefaultModel.unlinkedAccount();
    const nextID = "100";
    const didCreateID = Account.initAll().filter(item => item.id === nextID).length > 0;
    const newAccountNumber = "1500306800";
    let addedUnlinkedAcc = defaultUnlinkedAcc;
    
    // Batch updates in this capture will reload this component,
    // so prevent the creation of the same account id.
    if(!didCreateID) {
        addedUnlinkedAcc = Account.getNewAccountOfType(
            "unlinked",
            defaultAcc,
            defaultUnlinkedAcc,
            nextID, 
            Account.formatAccountNumber(newAccountNumber),
            defaultUnlinkedAcc.accountOwnerFirstName,
            defaultUnlinkedAcc.accountOwnerFirstName
        );
    } 

    // START: This code is to account for branding which affects which fields/props are filled out
    // when creating a new unlinked account.
    const form = AddUnlinkedTransferAccountForm.init({
        accountNickname: addedUnlinkedAcc.accountOwnerFirstName,
        accountOwnerType: addedUnlinkedAcc.accountOwnerType,
        firstNameOfAccountOwner: addedUnlinkedAcc.accountOwnerFirstName,
        lastNameOfAccountOwner: addedUnlinkedAcc.accountOwnerLastName,
        accountType: addedUnlinkedAcc.subtype,
        accountNumber: newAccountNumber,
        confirmAccountNumber: newAccountNumber
    }, branding);

    // This formUI class handles shown/removed fields from branding.
    const formUI = AddUnlinkedTransferAccountFormUI.init(form, branding);

    addedUnlinkedAcc.accountOwnerType = hasConsumerAccounts ? "personal" : "business";
    addedUnlinkedAcc.accountOwnerFirstName = formUI.firstNameOfAccountOwner ? addedUnlinkedAcc.accountOwnerFirstName : "";
    addedUnlinkedAcc.accountOwnerLastName = formUI.lastNameOfAccountOwner ? addedUnlinkedAcc.accountOwnerLastName : "";
    addedUnlinkedAcc.accountOwnerType = formUI.accountOwnerType ? addedUnlinkedAcc.accountOwnerType : "";
    // END: This code is to account for branding which affects which fields/props are filled out
    // when creating a new unlinked account.

    const newRecords = [
        UnlinkedAccount.update(addedUnlinkedAcc.record)
    ];

    // Update unlinked account props to account for branding when the account was created.
    BCMSRecord.batch(newRecords, context, Classes);

    addedUnlinkedAcc = UnlinkedAccount.initByID(nextID);
    
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "transfer", "from" ], checkingAccount)
    .update([ "transfer", "to" ], addedUnlinkedAcc.id ? addedUnlinkedAcc : undefined )
    .update([ "transfer", "amount" ], "1.00")
    .update([ "transfer", "schedule" ], transferScheduleImmediateLabel)
    .update([ "transfer", "description" ], "Test")
    .submit();

    return <TransferConfirmPage data={ data } className="for-capture"/>
}